import { render } from "./FormManagementView.vue?vue&type=template&id=b378ed72&scoped=true"
import script from "./FormManagementView.vue?vue&type=script&lang=js"
export * from "./FormManagementView.vue?vue&type=script&lang=js"

import "./FormManagementView.vue?vue&type=style&index=0&id=b378ed72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b378ed72"]])

export default __exports__